import { useState, useEffect } from "react";
import Loading from "../../../Component/Customers/Cards/Loading.jsx";
import NoDataFound from "../../../Component/Customers/Cards/NoDataFound.jsx";
import axios from 'axios';
import reachedUser from '../../../Assets/reachedUser.png'
import filterUser from '../../../Assets/filterUser.png'
import workDoneUser from '../../../Assets/workDoneUser.png'
import searchinterfacesymbol from '../../../Assets/search-interface-symbol.png'
import historyUser from '../../../Assets/historyUser.png'
import crossUser from '../../../Assets/crossUser.png'
import assignedTask from '../../../Assets/assignedTask.png'
import comingCrane from '../../../Assets/comingCrane.png'
import checksuccess from '../../../Assets/checksuccess.png'
import ratingStar from '../../../Assets/ratingStar.png'
import dropReason from '../../../Assets/dropReason.png'
import Modal from "../../../Component/CompanyAdmin/Location1/Modal.jsx";
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import SignalWifiBadIcon from '@mui/icons-material/SignalWifiBad';
import searchIcon from '../../../Assets/home2/search.svg'

import icon11 from '../../../Assets/crane/icon11.svg'
import icon12 from '../../../Assets/crane/icon12.svg'
import icon13 from '../../../Assets/crane/icon13.svg'
import icon14 from '../../../Assets/crane/icon14.svg'
import icon15 from '../../../Assets/crane/icon15.svg'
import icon16 from '../../../Assets/crane/icon16.svg'
import icon17 from '../../../Assets/crane/icon17.svg'
import starIcon from '../../../Assets/crane/star.svg'
import icon7 from '../../../Assets/crane/icon7.svg'
import navbarRightArrowIcon from '../../../Assets/navbar/right-arrow.svg'
import CraneSideBar from '../../../Component/Customers/slidebar/CraneSideBar.jsx'

import { layerGroup } from "leaflet";

const btns = [
    { name: "Pre Cancelled", id: 1 },
    { name: "Post Cancelled", id: 2 },
]


const AllCancelledOrders = ({ vehicleNumber }) => {

    const [preCancelledOrders, setPreCancelledOrders] = useState([]);
    const [postCancelledOrdrs, setPostCancelledOrders] = useState([]);
    const [data, setData] = useState([]);
    const [filtering, setFiltering] = useState([]);

    const [doneFetching, setDoneFetching] = useState(false)
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [searchValue, setSearchValue] = useState('');

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");

    const [openFilterModal, setOpenFilterModal] = useState(false)
    const [avg, setAvg] = useState([])

    const [currentStage, setCurrentStage] = useState([]); // Example stage
    const [isHistoryPage, setIsHistoryPage] = useState(false);
    const [reasonPage, setReasonPage] = useState(false);
    const [currentItem, setCurrentItem] = useState([])

    const [stages, setStages] = useState([]);

        const currentService = localStorage.getItem("currentService");
        const [currentServiceImage, setCurrentServiceImage] = useState(null);
        useEffect(() => {
            if (currentService == 'crane') setCurrentServiceImage('https://www.ace-cranes.com/images/productimage/168993867620230721.png')
            if (currentService == 'recoveryVan') setCurrentServiceImage('https://www.ace-cranes.com/images/productimage/168993867620230721.png')
        }, [currentService])
    
    

    useEffect(() => {
        setDoneFetching(false)
        getData()
    }, [userId, token, currentService])

    const getData = async (e) => {
        //console.log("userid", userId);
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getCancelledOrdersByCustomers/${userId}/${currentService}/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
        if (response.data.message === "No accident vehicle data found.") {
            setPreCancelledOrders([])
            setPostCancelledOrders([])
            doneFetching(true)
        }
        else {
            //console.log("response123421", response.data.data);
            //console.log("data2", response.data.data2);
            setFiltering(response.data.data)
            setData(response.data.data)
            setPreCancelledOrders(response.data.data)
            setPostCancelledOrders(response.data.data2);
            setDoneFetching(true)
        }
    };

    useEffect(() => {
        if (data.length > 0 && data.length != currentStage.length) {
            data.map(() => {
                avg.push(0)
            })
        }
    }, [data])

    const getFilteredData = (filter) => {
        const filteredData = [];

        const now = new Date();  // Current date and time
        const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
        const yesterday = new Date(now.getTime() - oneDay); // Yesterday's date and time
        const weekBefore = new Date(now.getTime() - (oneDay * 7));
        const monthBefore = new Date(now.getTime() - (oneDay * 30));

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        const todayDate = formatDate(now);
        const yesterdayDate = formatDate(yesterday);
        const weekBeforeDate = formatDate(weekBefore)
        const monthBeforeDate = formatDate(monthBefore)

        //console.log("todayDate", todayDate)
        //console.log("yesterdayDate", yesterdayDate)


        for (let i = 0; i < filtering.length; i++) {

            let getTime = filtering[i]?.cancelledAt?.split('|');
            let cancelledDate = getTime[0];
            let cancelledTime = getTime[1];
            let cancelledDateTime = new Date(`${cancelledDate} ${cancelledTime}`);

            if (filter === 'daily') {
                //console.log("here i am daily")
                if (cancelledDate === todayDate || cancelledDate === yesterdayDate) {
                    const timeDifference = now - cancelledDateTime;
                    if (timeDifference <= oneDay) {
                        //console.log("Match found within last 24 hours:", data[i]);
                        filteredData.push(filtering[i]);
                    }
                }
            }
            else if (filter === 'weekly') {
                //console.log("here i am weekly")
                if (cancelledDateTime >= weekBefore && cancelledDateTime <= now) {
                    //console.log("Match found within last 7 days:", data[i]);
                    filteredData.push(filtering[i]);
                }
            }
            else if (filter === 'monthly') {
                if (cancelledDateTime >= monthBefore && cancelledDateTime <= now) {
                    //console.log("Match found within last 30 days:", data[i]);
                    filteredData.push(filtering[i]);
                }
            }
            else if (filter === 'year') {
                const yearBefore = new Date(now.getTime() - (oneDay * 365)); // Calculate date one year ago
                if (cancelledDateTime >= yearBefore && cancelledDateTime <= now) {
                    //console.log("Match found within last year:", filtering[i]);
                    filteredData.push(filtering[i]);
                }
            }

        }
        if (filter === 'newest') {
            //console.log("Sorting by newest to oldest");
            //console.log("filtering", filtering[0])
            filtering.sort((a, b) => {
                //console.log("a?.cancelledAt", a?.cancelledAt)
                const dateA = new Date(a?.cancelledAt?.split('|').join(' '));
                const dateB = new Date(b?.cancelledAt?.split('|').join(' '));
                return dateB - dateA; // Descending order
            });
            setData([...filtering]);
        }
        else if (filter === 'oldest') {
            //console.log("Sorting by oldest to newest");
            filtering.sort((a, b) => {
                const dateA = new Date(a?.cancelledAt?.split('|').join(' '));
                const dateB = new Date(b?.cancelledAt?.split('|').join(' '));
                return dateA - dateB; // Ascending order
            });
            setData([...filtering]);
        }
        else {
            setData(filteredData)
        }
    };

    useEffect(() => {
        //console.log("hello", currentStage);
        if (currentStage[0]) {
            //console.log("helasdfasdflo");
            //console.log("currentStage[0][0] ", currentStage[0])
            setStages([
                { label: "Filed", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/assignedTask.png', date: currentStage[0][0] },
                { label: "Vendor Assigned", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/checksuccess.png', date: currentStage[0][1] },
                { label: "Accepted & Moved", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/comingCrane.png', date: currentStage[0][2] },
                { label: "Reached", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/reachedUser.png', date: currentStage[0][3] },
                { label: "Work Done", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/workDoneUser.png', date: currentStage[0][4] },
                { label: "Cancelled", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crossUser.png', date: currentStage[0][5] },

            ]);
        }
    }, [currentStage[0]]);

    const getStage = (systemDate, connectedVendorFully, vendorMovedTime, vendorReachedTime, doneWorkingTime, cancelledAt) => {
        const stages = [systemDate, connectedVendorFully, vendorMovedTime, vendorReachedTime, doneWorkingTime, cancelledAt]
        //console.log("stage", stages)
        // return stages.filter((item) => item != "")
        return stages;
    }

    const getStageAndHistory = (item, index) => {
        //console.log("tem?.cancelledAt", item?.cancelledAt)
        //console.log("systemDate, vendorMovedTime, vendorReachedTime, doneWorkingTime, cancelledAt", item?.systemDate, item?.connectedVendorFully ? item?.connectedVendorFullyTime : "hey", item?.customerAcceptedVendor ? item?.customerAcceptedVendorTime : "hey", item?.vendorMoved ? item.vendorMovedTime : "hey", item.vendorReached ? item?.vendorReachedTime : "hey", item.doneWorking ? item?.doneWorkingTime : "hey", item?.cancelledAt)
        let gotStage = getStage(item?.systemDate, item?.connectedVendorFully ? item?.connectedVendorFullyTime : "", item?.vendorMoved ? item.vendorMovedTime : "", item.vendorReached ? item?.vendorReachedTime : "", item.doneWorking ? item?.doneWorkingTime : "", item?.cancelledAt)
        //console.log("GOTSTEAG", gotStage)
        setCurrentStage((prevStages) => [gotStage, ...prevStages]);
        setIsHistoryPage(true)
    }

    const getReason = (item, index) => {
        setCurrentItem(item)
        setReasonPage(true)
    }
    // const getStage = (filedCaseFullyTime, customerAcceptedVendorTime, vendorMovedTime, vendorReachedTime, doneWorkingTime) => {
    //     console.log("filedCaseFullyTime, customerAcceptedVendorTime, vendorMovedTime, vendorReachedTime, doneWorkingTime ||||||||||||", filedCaseFullyTime, customerAcceptedVendorTime, vendorMovedTime, vendorReachedTime, doneWorkingTime)
    //     return [filedCaseFullyTime, customerAcceptedVendorTime, vendorMovedTime, vendorReachedTime, doneWorkingTime]
    // }
    // const getStageAndHistory = (item, index) => {
    //     let gotStage = getStage(item?.filedCaseFullyTime, item?.customerAcceptedVendorTime, item?.vendorMovedTime, item?.vendorReachedTime, item?.doneWorkingTime)
    //     currentStage.unshift(gotStage)
    //     setIsHistoryPage(true)
    // }


    useEffect(() => {
        if (vehicleNumber && filtering.length > 0) {
            setSearchValue(vehicleNumber);
            handleSearch(vehicleNumber);
        }
    }, [vehicleNumber, filtering]);

    useEffect(() => {
        return () => setSearchValue('');
    }, []);

    const handleSearch = (inputValue) => {
        const value = inputValue?.toLowerCase() ?? searchValue.toLowerCase()
        setSearchValue(value);
        const newRows = filtering.filter((row) => {
            //console.log('red1231', row)
            const formattedId = String(row.id).padStart(4, '0').toLowerCase();
            const idValue = formattedId.includes(value);
            const vehicleNoValue = (row.reg ?? '').toLowerCase().includes(value);
            const chassisNoValue = (row.accidentFileNo ?? '').toLowerCase().includes(value);
            return idValue || vehicleNoValue || chassisNoValue;
        });
        setData(newRows);
    };

    const handleSelect = (index) => {
        setSelectedIndex(index);
        //console.log("SELECTEDINDOEX", index)
        //console.log("filtering", filtering)

        if (index === 0) {
            setFiltering([...preCancelledOrders]);
            setData([...preCancelledOrders]);
        } else {
            setFiltering([...postCancelledOrdrs]);
            setData([...postCancelledOrdrs]);
        }
    };

    const settingFilter = (filter) => {
        //console.log("filter", filter)
        getFilteredData(filter)
        setOpenFilterModal(false)
    }

    const [hBtn, setHBtn] = useState("Pre Cancelled")
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isReason, setReason] = useState(false);

    const callButtonClick = (e) => {

        console.log(e);
        setHBtn(e)
        let index = e === 'Pre Cancelled' ? 0 : 1;
        console.log(index);
        handleSelect(index)

        console.log(preCancelledOrders);
    }

    return (
        <>
            {/* <div className='crane-section'>
                <h6 className="font-[700] text-center font-satoshi text-[61px] leading-[68px] text-[#FFFFFF] pt-[52px] mb-0 pb-[72px]">
                    Crane Service</h6>
                <div style={{ backdropFilter: "blur(20px)" }} className="flex bg-[#FFFFFF4D] max-w-[736px] w-full mx-auto py-[28px] rounded-[66px] pl-[40px] mb-[78px] pr-[28px] items-center justify-between">
                    <input type="text" className='outline-none bg-transparent text-[#FFFFFF] placeholder:text-[#FFFFFF] font-[500] text-[16px] leading-[20px]' placeholder='Search By Service' />
                    <img src={searchIcon} style={{ height: "23px", width: "23px" }} alt="" />

                </div>
            </div> */}
            <div className='bg-white flex md:flex-row flex-col justify-center gap-[30px]'>
                <CraneSideBar />
                <div className='max-w-[979px] py-[38px] px-[40px] w-full bg-[#EFF9FD] border-[1px] border-[#E7E4FC] rounded-[12px]'>
                    <h6 className="font-[700] font-satoshi text-[30px] text-[#0A0119] m-0 pb-[30px]">Cancelled Orders</h6>
                    <div className="flex gap-[12px] pb-[26px]">
                        {btns?.map((e) => {
                            return (
                                <>
                                    <button key={e?.id}
                                        onClick={() => callButtonClick(e?.name)}
                                        // onClick={() => setHBtn(e?.name)} 
                                        className={`rounded-[92px] font-satoshi text-[16px] border-[1px] py-[14px] max-w-[202px] w-full ${hBtn === e?.name ? "bg-[#21A6E9] text-[#FFFFFF] border-[#E7E4FC] font-[700]" : "bg-[#FFFFFF] text-[#000000] border-[#E7E4FC] font-[400]"}`}>{e?.name}</button>
                                </>
                            )
                        })}
                    </div>
                    {data.length > 0 && (
                        <div>
                            {hBtn === "Pre Cancelled" &&
                                <div className="grid md:grid-cols-2 grid-cols-1 gap-[23px]">

                                    {data.map((item, dataIndex) => (

                                        <div className="bg-[#FFFFFF] border-[1px] border-[#E7E4FC] py-[40px] md:px-[30px] px-[14px] rounded-[12px]">

                                            <ol className="flex items-start gap-[3px] justify-between his-line max-w-[536px] pl-0 mb-0 mx-auto w-full">
                                                <li className='h-full w-[38px]' title={item?.[`${currentService}Details`]?.systemDate?.replace('T', ' | ').replace('.000Z', '')} >
                                                    <div className="flex flex-col items-center gap-[6px]">
                                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon12.svg' className='h-[38px] w-[38px]' alt="" />
                                                        <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Filed</p>
                                                    </div>
                                                </li>
                                                <li className='w-[60px]' title={item?.[`${currentService}Details`]?.customerAcceptedVendorTime?.replace('T', ' | ').replace('.000Z', '')}>
                                                    <div className="flex flex-col items-center gap-[6px]">
                                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon13.svg' className='h-[38px] w-[38px]' alt="" />
                                                        <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Vendor Assigned</p>
                                                    </div>
                                                </li>
                                                <li className='w-[60px]' title={item?.[`${currentService}Details`]?.vendorMovedTime?.replace('T', ' | ').replace('.000Z', '')}>
                                                    <div className="flex flex-col items-center gap-[6px]">
                                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon14.svg' className='h-[38px] w-[38px]' alt="" />
                                                        <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Accepted & Moved</p>
                                                    </div>
                                                </li>
                                                <li className='w-[60px]' title={item?.[`${currentService}Details`]?.vendorReachedTime?.replace('T', ' | ').replace('.000Z', '')}>
                                                    <div className="flex flex-col items-center gap-[6px]">
                                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon15.svg' className='h-[38px] w-[38px]' alt="" />
                                                        <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Reached</p>
                                                    </div>
                                                </li>
                                                <li className='w-[60px]' title={item?.[`${currentService}Details`]?.doneWorkingTime?.replace('T', ' | ').replace('.000Z', '')}>
                                                    <div className="flex flex-col items-center gap-[6px]">
                                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon16.svg' className='h-[38px] w-[38px]' alt="" />
                                                        <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Work Done</p>
                                                    </div>
                                                </li>
                                                <li className='w-[60px]' >
                                                    <div className="flex flex-col items-center gap-[6px]">
                                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon17.svg' className='w-[38px] w-[20px]' alt="" />
                                                        <p className="m-0 font-[500] font-satoshi md:text-[13px] text-[10px] text-[#21A6E9] text-center">Cancelled</p>
                                                    </div>
                                                </li>
                                            </ol>

                                            <div className="flex md:flex-row flex-col pt-[37px] pb-[29px] gap-[14px]">
                                                <div className="flex gap-[20px] items-center w-full">
                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon11.svg' className='h-[82px] w-[82px]' alt="" />
                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item?.reg}</h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Vehicle No</p>
                                                    </div>
                                                </div>
                                                <div className='flex sm:flex-col  md:items-end items-center w-full gap-[20px]'>
                                                    <button className='bg-[#EFF9FD] rounded-full py-[6px] px-[8px] flex items-center gap-[8px] text-[#5B5F5F] font-[400] font-satoshi'><img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/star.svg' alt="" /> 0</button>
                                                    <button className='bg-[#F03E39] border-[1px] border-[#E7E4FC] py-[10px] px-[22px] text-[#FFFFFF] font-satoshi font-[700] text-[10px] text-center rounded-full'>Pre Cancelled</button>
                                                </div>
                                            </div>
                                            <div className="grid sm:grid-cols-2 gap-[60px] gap-y-[20px]">
                                                <div>
                                                    <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item?.systemDate.split("T")[0]}</h6>
                                                    <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Registered Date</p>
                                                </div>
                                                <div>
                                                    <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item?.systemDate.split("T")[1].split(':')[0]}:{item?.systemDate.split("T")[1].split(':')[1]} AM</h6>
                                                    <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Time</p>
                                                </div>
                                                <div>
                                                    <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item?.cancelledAt?.split("T")[0]}</h6>
                                                    <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Cancelled Date</p>
                                                </div>
                                                <div>
                                                    <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item?.cancelledAt?.split("T")[1].split(':')[0]}:{item?.cancelledAt?.split("T")[1].split(':')[1]} PM</h6>
                                                    <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Time</p>
                                                </div>
                                            </div>
                                            <button onClick={() => { setIsModalOpen(true) }} className='  mt-[30px] py-[10px] px-[30px] bg-[#FFFFFF] text-[#21A6E9] border-[1px] w-full rounded-full font-satoshi font-[400] text-[24px] leading-[33px] outline-none border-[#21A6E9]'>
                                                Reason
                                            </button>

                                            {/* <select name="" id="" className='mt-[30px] pointer-events-none py-[10px] px-[30px] bg-[#FFFFFF] text-[#21A6E9] border-[1px] w-full rounded-full font-satoshi font-[400] text-[24px] leading-[33px] outline-none border-[#21A6E9]'>
                                    <option value="">Reason</option>
                                    <option value="">Reason 1</option>
                                    <option value="">Reason 2</option>
                                    <option value="">Reason 3</option>
                                </select> */}
                                        </div>

                                    ))}


                                </div>
                            }
                            {hBtn === "Post Cancelled" &&
                                <div className="grid md:grid-cols-2 grid-cols-1 gap-[23px]">

                                    {data.map((item, dataIndex) => (

                                        <div className="bg-[#FFFFFF] border-[1px] border-[#E7E4FC] py-[40px] md:px-[30px] px-[14px] rounded-[12px]">

                                            <ol className="flex items-start gap-[3px] justify-between his-line max-w-[536px] pl-0 mb-0 mx-auto w-full">
                                                <li className='h-full w-[38px]' title={item?.[`${currentService}Details`]?.systemDate?.replace('T', ' | ').replace('.000Z', '')} >
                                                    <div className="flex flex-col items-center gap-[6px]">
                                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon12.svg' className='h-[38px] w-[38px]' alt="" />
                                                        <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Filled</p>
                                                    </div>
                                                </li>
                                                <li className='w-[60px]' title={item?.[`${currentService}Details`]?.customerAcceptedVendorTime?.replace('T', ' | ').replace('.000Z', '')}>
                                                    <div className="flex flex-col items-center gap-[6px]">
                                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon13.svg' className='h-[38px] w-[38px]' alt="" />
                                                        <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Vendor Assigned</p>
                                                    </div>
                                                </li>
                                                <li className='w-[60px]' title={item?.[`${currentService}Details`]?.vendorMovedTime?.replace('T', ' | ').replace('.000Z', '')}>
                                                    <div className="flex flex-col items-center gap-[6px]">
                                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon14.svg' className='h-[38px] w-[38px]' alt="" />
                                                        <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Accepted & Moved</p>
                                                    </div>
                                                </li>
                                                <li className='w-[60px]' title={item?.[`${currentService}Details`]?.vendorReachedTime?.replace('T', ' | ').replace('.000Z', '')}>
                                                    <div className="flex flex-col items-center gap-[6px]">
                                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon15.svg' className='h-[38px] w-[38px]' alt="" />
                                                        <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Reached</p>
                                                    </div>
                                                </li>
                                                <li className='w-[60px]' title={item?.[`${currentService}Details`]?.doneWorkingTime?.replace('T', ' | ').replace('.000Z', '')}>
                                                    <div className="flex flex-col items-center gap-[6px]">
                                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon16.svg' className='h-[38px] w-[38px]' alt="" />
                                                        <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Work Done</p>
                                                    </div>
                                                </li>
                                                <li className='w-[60px]' >
                                                    <div className="flex flex-col items-center gap-[6px]">
                                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon17.svg' className='w-[38px] w-[20px]' alt="" />
                                                        <p className="m-0 font-[500] font-satoshi md:text-[13px] text-[10px] text-[#21A6E9] text-center">Cancelled</p>
                                                    </div>
                                                </li>
                                            </ol>

                                            <div className="flex md:flex-row flex-col pt-[37px] pb-[29px] gap-[14px]">
                                                <div className="flex gap-[20px] items-center w-full">
                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon11.svg' className='h-[82px] w-[82px]' alt="" />
                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item?.reg}</h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Vehicle No</p>
                                                    </div>
                                                </div>
                                                <div className='flex flex-col md:items-end items-center w-full gap-[20px]'>
                                                    <button className='bg-[#EFF9FD] rounded-full py-[6px] px-[8px] flex items-center gap-[8px] text-[#5B5F5F] font-[400] font-satoshi'><img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/star.svg' alt="" /> 0</button>
                                                    <button className='bg-[#F03E39] border-[1px] border-[#E7E4FC] py-[10px] px-[22px] text-[#FFFFFF] font-satoshi font-[700] text-[10px] text-center rounded-full'>Post Cancelled</button>
                                                </div>
                                            </div>
                                            <div className="grid sm:grid-cols-2 gap-[60px] gap-y-[20px]">
                                                <div>
                                                    <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item?.systemDate.split("T")[0]}</h6>
                                                    <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Registered Date</p>
                                                </div>
                                                <div>
                                                    <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item?.systemDate.split("T")[1].split(':')[0]}:{item?.systemDate.split("T")[1].split(':')[1]} AM </h6>
                                                    <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Time</p>
                                                </div>
                                                <div>
                                                    <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item?.cancelledAt?.split("T")[0]}</h6>
                                                    <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Cancelled Date</p>
                                                </div>
                                                <div>
                                                    <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item?.cancelledAt?.split("T")[1].split(':')[0]}:{item?.cancelledAt?.split("T")[1].split(':')[1]} PM</h6>
                                                    <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Time</p>
                                                </div>
                                            </div>
                                            <button onClick={() => { setIsModalOpen(true) }} className='mt-[30px] py-[10px] px-[30px] bg-[#FFFFFF] text-[#21A6E9] border-[1px] w-full rounded-full font-satoshi font-[400] text-[24px] leading-[33px] outline-none border-[#21A6E9]'>
                                                Reason
                                            </button>
                                        </div>
                                    ))}

                                </div>
                            }
                        </div>
                    )}
                    {data.length == 0 && (
                        <NoDataFound />
                    )}
                </div>
            </div>

            <ReasonModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
        </>
    )
}

const ReasonModal = ({ isOpen, onClose, }) => {

    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
            <div className="bg-white py-[27px] md:px-[48px] px-[30px] rounded-[30px] shadow-lg w-[90%] overflow-y-scroll md:w-[704px]">
                <div className="flex justify-between items-center">
                    <h6 className="m-0 font-[500] font-satoshi text-[31px] text-[#000000]">Reason</h6>
                    <img onClick={onClose} src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon7.svg' className='h-[35px] w-[35px]' alt="" />
                </div>
                <p className="m-0 font-satoshi font-[500] text-[16px] text-[#000000] pt-[30px] pb-[14px]">Reason To Cancel Order</p>
                <p className="rounded-[7px] py-[16px] px-[10px] bg-[#F6F6F6] border-[#DEDEE8] border-[1px] font-satoshi font-[500] text-[16px] text-[#000000]">Changed My Mind,</p>
                <div className="flex justify-center md:pt-[54px] pt-[20px]">
                    <div className=" hidden bg-[#21A6E9] flex  py-[5px] rounded-full pr-[6px] pl-[26px]">
                        <button onClick={onClose} className="font-satoshi font-[400] text-[18px] leading-[33.6px] pr-[56px] text-[#FFFFFF]">Submit</button>
                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllCancelledOrders;